import React from 'react';
import {IconButton, Tooltip, Typography} from '@mui/material';
import AttachmentIcon from '@mui/icons-material/AttachFile';
import {useTranslation} from 'react-i18next';
import {useTheme} from '@mui/material/styles';
import TileButton from './TileButton';
import {CHAT_ACCEPTED_FILE_FORMATS} from "../../../../config/chat.constants";

interface AttachmentIconButtonProps {
    handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disable?: boolean;
}

const FileFromDiscButton = ({handleFileChange, disable}: AttachmentIconButtonProps) => {
    const {t} = useTranslation();
    const theme = useTheme();

    return (
        <TileButton>
            <Tooltip title={t('attachFiles.addFileFromDisc')}>
                <label htmlFor="file-from-disc"
                       aria-label={t('attachFiles.addFileFromDisc') || ''}
                >
                    <input id="file-from-disc"
                           type="file"
                           accept={CHAT_ACCEPTED_FILE_FORMATS.map(f => f.name).join(',')}
                           multiple
                           style={{display: 'none'}}
                           onChange={disable ? undefined : handleFileChange}
                    />

                    <Typography color="primary" variant="button">
                        {t('attachFiles.fromDisc')}
                    </Typography>

                    <IconButton component="span"
                                sx={{
                                    '&:hover': {
                                        backgroundColor: 'transparent'
                                    },
                                    color: theme.palette.primary.main,
                                }}>
                        <AttachmentIcon/>
                    </IconButton>
                </label>
            </Tooltip>
        </TileButton>
    );
};

export default FileFromDiscButton;